<template>
    <Header></Header>
    <Left></Left>
    <section class="container pdf_area_class">
        <div>
            <div class="area_title">
                <p>예방홍보네트워크활동</p>
                <div class="area_button">
                    <button type="button" @click="downloadPdf">
                        <img src="img/print.png" />
                        <span>PDF 출력</span>
                    </button>
                </div>
            </div>
            <div class="area_body">
                <div class="area_section">
                    <div class="area_form">
                        <div class="area_form_title"><p>예방홍보네트워크활동 세부내역</p></div>
                        <div class="area_form_body">
                            <div class="area_row">
                                <div class="area_col_row" style="flex-direction: row">
                                    <div class="area_col" style="width: 50%; border-bottom: 0; border-right: 1px solid #d9d9d9">
                                        <div class="area_col_head"><label class="starMark">1. 작성일</label></div>
                                        <div class="area_col_body">
                                            <div class="datepicker">
                                                <input type="date" v-model="state.data.createDate" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col" style="width: 50%; border-bottom: 0; border-right: 1px solid #d9d9d9">
                                        <div class="area_col_head"><label class="starMark">2. 세부항목</label></div>
                                        <div class="area_col_body">
                                            <div class="select-wrap">
                                                <select v-model="state.data.type" class="w250">
                                                    <option value="">선택해주세요.</option>
                                                    <option v-for="item in CommonOptions.typeListForActivity" :value="item.key">
                                                        {{ item.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_row" style="flex-direction: row">
                                    <div class="area_col" style="width: 50%; border-bottom: 0; border-right: 1px solid #d9d9d9">
                                        <div class="area_col_head"><label class="starMark">3. 작성자</label></div>
                                        <div class="area_col_body">
                                            <div class="">
                                                <input type="text" v-model="state.data.writer" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col" style="width: 50%; border-bottom: 0; border-right: 1px solid #d9d9d9">
                                        <div class="area_col_head"><label class="starMark">4. 작성팀</label></div>
                                        <div class="area_col_body">
                                            <div class="select-wrap">
                                                <select v-model="state.data.team" class="w250">
                                                    <option value="">선택해주세요.</option>
                                                    <option v-for="item in CommonOptions.teamForActivity" :value="item.key">
                                                        {{ item.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label class="starMark">5. 제목</label></div>
                                <div class="area_col_body">
                                    <div class="full">
                                        <input type="text" v-model="state.data.title" />
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_row" style="flex-direction: row">
                                    <div class="area_col" style="width: 50%; border-bottom: 0; border-right: 1px solid #d9d9d9">
                                        <div class="area_col_head"><label class="starMark">6. 대상</label></div>
                                        <div class="area_col_body">
                                            <div class="radio_wrap">
                                                <template v-if="state.data.type !== '성매매예방교육'">
                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="promotionTarget"
                                                            :checked="state.data.promotionTarget === '일반인'"
                                                            @click="state.data.promotionTarget = '일반인'"
                                                        />
                                                        <em></em>
                                                        <span>일반인</span>
                                                    </label>

                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="promotionTarget"
                                                            :checked="state.data.promotionTarget === '관련기관실무자'"
                                                            @click="state.data.promotionTarget = '관련기관실무자'"
                                                        />
                                                        <em></em>
                                                        <span>관련기관실무자</span>
                                                    </label>

                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="promotionTarget"
                                                            :checked="state.data.promotionTarget === '성매매노출여성'"
                                                            @click="state.data.promotionTarget = '성매매노출여성'"
                                                        />
                                                        <em></em>
                                                        <span>성매매노출여성</span>
                                                    </label>

                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="promotionTarget"
                                                            :checked="state.data.promotionTarget === '위기청소년'"
                                                            @click="state.data.promotionTarget = '위기청소년'"
                                                        />
                                                        <em></em>
                                                        <span>위기청소년</span>
                                                    </label>

                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="promotionTarget"
                                                            :checked="state.data.promotionTarget === '성구매자'"
                                                            @click="state.data.promotionTarget = '성구매자'"
                                                        />
                                                        <em></em>
                                                        <span>성구매자</span>
                                                    </label>

                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="promotionTarget"
                                                            :checked="state.data.promotionTarget === '기타1'"
                                                            @click="state.data.promotionTarget = '기타1'"
                                                        />
                                                        <em></em>
                                                        <span>기타</span>
                                                    </label>
                                                </template>
                                                <template v-else-if="state.data.type.indexOf('기관연대') > -1">
                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="promotionTarget"
                                                            :checked="state.data.promotionTarget === '일반인'"
                                                            @click="state.data.promotionTarget = '일반인'"
                                                        />
                                                        <em></em>
                                                        <span>일반인</span>
                                                    </label>
                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="promotionTarget"
                                                            :checked="state.data.promotionTarget === '관련기관실무자'"
                                                            @click="state.data.promotionTarget = '관련기관실무자'"
                                                        />
                                                        <em></em>
                                                        <span>관련기관실무자</span>
                                                    </label>
                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="promotionTarget"
                                                            :checked="state.data.promotionTarget === '기타1'"
                                                            @click="state.data.promotionTarget = '기타1'"
                                                        />
                                                        <em></em>
                                                        <span>기타</span>
                                                    </label>
                                                </template>
                                                <template v-else>
                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="promotionTarget"
                                                            :checked="state.data.promotionTarget === '정부지자체'"
                                                            @click="state.data.promotionTarget = '정부지자체'"
                                                        />
                                                        <em></em>
                                                        <span>정부/지자체</span>
                                                    </label>
                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="promotionTarget"
                                                            :checked="state.data.promotionTarget === '공공기관'"
                                                            @click="state.data.promotionTarget = '공공기관'"
                                                        />
                                                        <em></em>
                                                        <span>공공기관</span>
                                                    </label>

                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="promotionTarget"
                                                            :checked="state.data.promotionTarget === '유관기관'"
                                                            @click="state.data.promotionTarget = '유관기관'"
                                                        />
                                                        <em></em>
                                                        <span>유관기관</span>
                                                    </label>

                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="promotionTarget"
                                                            :checked="state.data.promotionTarget === '재발방지 교육(여성)'"
                                                            @click="state.data.promotionTarget = '재발방지 교육(여성)'"
                                                        />
                                                        <em></em>
                                                        <span>재발방지 교육(여성)</span>
                                                    </label>
                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="promotionTarget"
                                                            :checked="state.data.promotionTarget === '보호관찰소'"
                                                            @click="state.data.promotionTarget = '보호관찰소'"
                                                        />
                                                        <em></em>
                                                        <span>성구매자재범 방지교육 (보호관찰소 존스쿨 교육)</span>
                                                    </label>

                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="promotionTarget"
                                                            :checked="state.data.promotionTarget === '경찰'"
                                                            @click="state.data.promotionTarget = '경찰'"
                                                        />
                                                        <em></em>
                                                        <span>검ㆍ경등 수사기관</span>
                                                    </label>
                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="promotionTarget"
                                                            :checked="state.data.promotionTarget === '군대'"
                                                            @click="state.data.promotionTarget = '군대'"
                                                        />
                                                        <em></em>
                                                        <span>군대</span>
                                                    </label>
                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="promotionTarget"
                                                            :checked="state.data.promotionTarget === '학교'"
                                                            @click="state.data.promotionTarget = '학교'"
                                                        />
                                                        <em></em>
                                                        <span>학교</span>
                                                    </label>

                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="promotionTarget"
                                                            :checked="state.data.promotionTarget === '민간 및 사기업'"
                                                            @click="state.data.promotionTarget = '민간 및 사기업'"
                                                        />
                                                        <em></em>
                                                        <span>민간기관 및 사기업 등</span>
                                                    </label>
                                                    <label>
                                                        <input
                                                            type="radio"
                                                            name="promotionTarget"
                                                            :checked="state.data.promotionTarget === '기타2'"
                                                            @click="state.data.promotionTarget = '기타2'"
                                                        />
                                                        <em></em>
                                                        <span>기타</span>
                                                    </label>
                                                </template>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col" style="width: 50%; border-bottom: 0; border-right: 1px solid #d9d9d9">
                                        <div class="area_col_head"><label>7. 인원수</label></div>
                                        <div class="area_col_row">
                                            <div class="area_col no-line-bottom">
                                                <div class="area_col_body"><label>[7.1. 홍보/교육/회의인원]</label></div>
                                            </div>
                                            <div class="area_col">
                                                <div class="area_col_body">
                                                    <div class="full">
                                                        <input type="number" v-model="state.data.cntVst" @input="CommonUtils.onlyInt" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="area_col no-line-bottom">
                                                <div class="area_col_body"><label>[7.2. 상담인원]</label></div>
                                            </div>
                                            <div class="area_col">
                                                <div class="area_col_body">
                                                    <div class="full">
                                                        <input type="number" v-model="state.data.cntEtccs" @input="CommonUtils.onlyInt" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_row" style="flex-direction: row">
                                    <div class="area_col" style="width: 50%; border-bottom: 0; border-right: 1px solid #d9d9d9">
                                        <div class="area_col_head"><label>8. 방법</label></div>
                                        <div class="area_col_body">
                                            <div class="radio_wrap">
                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="promotionMethod"
                                                        :checked="state.data.promotionMethod === '자료배포 및 부착'"
                                                        @click="state.data.promotionMethod = '자료배포 및 부착'"
                                                    />
                                                    <em></em>
                                                    <span>자료배포 및 부착</span>
                                                </label>

                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="promotionMethod"
                                                        :checked="state.data.promotionMethod === '물품배포'"
                                                        @click="state.data.promotionMethod = '물품배포'"
                                                    />
                                                    <em></em>
                                                    <span>물품배포</span>
                                                </label>

                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="promotionMethod"
                                                        :checked="state.data.promotionMethod === '대중매체활용'"
                                                        @click="state.data.promotionMethod = '대중매체활용'"
                                                    />
                                                    <em></em>
                                                    <span>대중매체 활용 인터뷰 및 출연</span>
                                                </label>

                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="promotionMethod"
                                                        :checked="state.data.promotionMethod === '이벤트성 행사'"
                                                        @click="state.data.promotionMethod = '이벤트성 행사'"
                                                    />
                                                    <em></em>
                                                    <span>이벤트성 기획행사</span>
                                                </label>

                                                <label>
                                                    <input
                                                        type="radio"
                                                        name="promotionMethod"
                                                        :checked="state.data.promotionMethod === '기타'"
                                                        @click="state.data.promotionMethod = '기타'"
                                                    />
                                                    <em></em>
                                                    <span>기타</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col" style="width: 50%; border-bottom: 0; border-right: 1px solid #d9d9d9">
                                        <div class="area_col_head"><label>9. 홍보물품수</label></div>
                                        <div class="area_col_body">
                                            <div class="full">
                                                <input type="number" v-model="state.data.cntGoods" @input="CommonUtils.onlyInt" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_row" style="flex-direction: row">
                                    <div class="area_col" style="width: 50%; border-bottom: 0; border-right: 1px solid #d9d9d9">
                                        <div class="area_col_head"><label>10. 업소수</label></div>
                                        <div class="area_col_body">
                                            <div class="full">
                                                <input type="number" v-model="state.data.cntStore" @input="CommonUtils.onlyInt" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="area_col" style="width: 50%; border-bottom: 0; border-right: 1px solid #d9d9d9">
                                        <div class="area_col_head"><label>11. 참여실무자</label></div>
                                        <div class="area_col_body">
                                            <div class="full">
                                                <input type="text" v-model="state.data.staff" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>12. 세부내용</label></div>
                                <div class="area_col_body textarea_wrap">
                                    <div class="full">
                                        <textarea v-model="state.data.content"></textarea>
                                        <p v-text="state.data.content"></p>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>13. 첨부파일</label></div>
                                <div class="area_col_body">
                                    <div class="area_file">
                                        <label for="area_file">
                                            <input id="area_file" type="file" placeholder="" @change="handleFiles" v-show="false" multiple />

                                            <div class="file_box_wrap">‘파일첨부’ 버튼을 클릭하여 첨부해주세요</div>
                                            <span class="file_upload_btn">파일첨부</span>
                                            <p class="p_info">※200M 이하 파일을 첨부해주세요.</p>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="area_row">
                                <div class="area_col_head"><label>14. 첨부파일목록</label></div>
                                <div class="area_col_body">
                                    <div class="file_list">
                                        <div class="file" v-for="(item, idx) in state.data.fileList" :key="idx">
                                            <div class="file_name" @click="downloadFile(item.file, item.realName)">
                                                <img src="img/file_ico.png" alt="" />
                                                <span>{{ item.realName }}</span>
                                                <img src="img/file_down_ico.png" alt="" />
                                            </div>
                                            <button class="file_del icon_wrap" @click="fileRemove(item.idx)">삭제</button>
                                        </div>

                                        <div class="file" v-for="(item, index) in state.file" :key="index">
                                            <div class="file_name" @click="downloadFileForOrigin(item)">
                                                <img src="img/file_ico.png" alt="" />
                                                <span class="file_name">{{ item.name }}</span>
                                            </div>
                                            <button class="file_del icon_wrap" @click="removeNewFile(index)">
                                                삭제
                                                <!-- <img src="img/close_02.png" alt="" /> -->
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="area_form_foot">
                            <div class="area_button">
                                <button type="button" class="" @click="router.push({ name: 'activity' })">목록</button>
                                <template v-if="state.mode">
                                    <button type="button" class="active" @click="confirmAdd">등록</button>
                                </template>
                                <template v-else>
                                    <button type="button" class="active" @click="confirmModify">저장</button>
                                    <button type="button" class="danger" @click="confirmRemove">삭제</button>
                                </template>

                                <button type="button" class="" @click="reset">초기화</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <Spinner :is-full-page="true" v-if="state.isLoading"></Spinner>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        :gubun="state.gubun"
        @close="closeModal"
        @callback="callbackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        Left,
        Header,
        reactive,
        apiService,
        onMounted,
        router,
        ModalDefault,
        types,
        getMessageByCode,
        CommonUtils,
        CommonOptions,
        ItemAdd,
        watch,
        useRoute,
        Spinner,
        ref,
        userStore,
    } from "@/BaseComponent";

    export default {
        components: { ModalDefault, ItemAdd, Left, Header, Spinner },

        setup() {
            const user = userStore();
            const route = useRoute();
            const state = reactive({
                idx: 0 as number,
                data: {} as types.activity.CampaignNetworkVOForApi | any,
                mode: true as boolean, // true: insert, false: update

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                file: [] as Array<File>,
                gubun: 1 as 1 | 2 | 3, // 1: update, 2: delete, 3: insert

                isLoading: false,
            });
            const isPdfMode = ref(false);

            onMounted(() => {
                if (route.params.id) {
                    state.idx = Number(route.params.id);
                    detail();
                    state.mode = false;
                } else {
                    state.mode = true;
                    state.data.createDate = CommonUtils.getToday("");
                    state.data.writer = user.userInfo.name as string;
                }
            });

            watch(
                () => route.params.id,
                () => {
                    if (route.params.id) {
                        state.idx = Number(route.params.id);
                        detail();
                        state.mode = false;
                    } else {
                        state.mode = true;
                    }
                },
            );

            const detail = async () => {
                state.file = [];
                const res = await apiService.activity.detail(state.idx);

                if (res.returnCode === 0) {
                    if (res.data) {
                        state.data = res.data;

                        state.data.createDate = CommonUtils.dateFormatYYYYMMDD(state.data.date, "-");
                    }
                }
            };

            const showModal = () => {};

            const closeModal = () => {
                if (state.modalTab === 3) {
                    router.back();
                } else {
                    state.isShowModal = false;
                }
            };

            const reset = () => {
                if (state.idx) {
                    detail();
                } else {
                    state.data = {};
                }
            };

            const callbackModal = (param: any) => {
                if (param.action === "confirm") {
                    switch (param.gubun) {
                        case 1:
                            modify(param.path);
                            break;
                        case 2:
                            remove();
                            break;
                        case 3:
                            add();
                            break;
                    }
                } else if (param.action === "callback") {
                    switch (param.gubun) {
                        case 1:
                            detail();

                            break;
                        case 2:
                            router.back();
                            break;
                        case 3:
                            router.push({ name: "activity" });
                            break;
                    }
                    state.isShowModal = false;
                }
            };

            const confirmAdd = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 등록하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 3;
            };
            const confirmModify = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 변경하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 1;
            };

            const confirmRemove = () => {
                state.modalTab = 1;
                state.modalTitle = "알림";
                state.modalContent = "정말 삭제하시겠습니까?";
                state.isShowModal = true;
                state.gubun = 2;
            };

            const handleFiles = (e: any) => {
                const target = e.target as HTMLInputElement;
                if (!target.files) return;

                const files: File[] = Array.from(target.files);
                state.file = files;
                target.value = "";
            };

            const fileRemove = async (idxFile: number) => {
                const res = await apiService.activity.removeForFile(state.idx, idxFile);
                if (res.returnCode === 0) {
                    const index = state.data.fileList.findIndex((item: any) => item.idx === idxFile);
                    if (index !== -1) {
                        state.data.fileList.splice(index, 1);
                    }
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = 8;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const removeNewFile = (index: number) => {
                state.file.splice(index, 1);
            };

            const downloadFile = async (fileUrl: string, fileName: string) => {
                const res = await fetch(fileUrl);
                const blob = await res.blob();
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                URL.revokeObjectURL(link.href);
            };

            const downloadFileForOrigin = async (file: any) => {
                const link = document.createElement("a");
                link.href = URL.createObjectURL(file);
                link.download = file.name;
                link.click();
                URL.revokeObjectURL(link.href);
            };

            const add = async () => {
                const param: types.activity.ReqActivity = state.data;
                param.file = state.file;

                const res = await apiService.activity.add(param);
                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                    state.gubun = 3;
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const modify = async (path?: string) => {
                const param: types.activity.ReqActivityForModify = state.data;
                param.file = state.file;

                const res = await apiService.activity.modify(param);
                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "알림";
                    state.modalContent = "수정되었습니다.";
                    state.isShowModal = true;
                    state.gubun = 1;
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const remove = async () => {
                const res = await apiService.activity.remove(Number(route.params.id));
                if (res.returnCode === 0) {
                    state.modalTab = 3;
                    state.modalTitle = "알림";
                    state.modalContent = "삭제되었습니다.";
                    state.isShowModal = true;
                    state.gubun = 2;
                } else {
                    console.error(res.description);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const downloadPdf = async () => {
                state.isLoading = true;
                isPdfMode.value = true; // PDF 스타일 적용

                // const el = document.getElementById("pdfArea");

                window.print();

                // await nextTick(); // DOM 업데이트 반영 후 캡처
                // await CommonUtils.downloadPdf();

                isPdfMode.value = false; // 다시 원상복귀

                state.isLoading = false;
                // const param: types.client.ReqClientSupportCard = {
                //     startDate: state.startDate,
                //     endDate: state.endDate,
                // };
                // const res = await apiService.client.exportPdfForSupportCard(state.idx, param);
                // if (res) {
                //     if (res.returnCode) {
                //         console.error(res.returnCode);
                //         console.error(getMessageByCode(res.returnCode));
                //     } else {
                //         const blob = new Blob([res.data], {
                //             type: "application/pdf",
                //         });
                //         const disposition = res.headers["content-disposition"];
                //         let fileName = "download.pdf";
                //         if (disposition) {
                //             const match = disposition.match(/filename="?(.+)"?/);
                //             if (match && match[1]) {
                //                 fileName = decodeURIComponent(match[1]);
                //             }
                //         }
                //         const a = document.createElement("a");
                //         const url = window.URL.createObjectURL(blob);
                //         a.href = url;
                //         a.download = fileName;
                //         document.body.appendChild(a);
                //         a.click();
                //         document.body.removeChild(a);
                //         URL.revokeObjectURL(url);
                //     }
                // } else {
                //     state.modalTab = -1;
                //     state.modalTitle = "알림";
                //     state.modalContent = getMessageByCode(res.returnCode);
                //     state.isShowModal = true;
                // }
            };

            return {
                state,
                router,
                reset,
                CommonUtils,
                CommonOptions,
                showModal,
                closeModal,
                callbackModal,
                confirmAdd,
                confirmModify,
                confirmRemove,
                handleFiles,
                downloadFile,
                downloadFileForOrigin,
                fileRemove,
                removeNewFile,
                window,
                downloadPdf,
            };
        },
    };
</script>
